import styled, { css } from "styled-components";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

// Styled label for the form
export const FormLabel = styled.label<{ $textColor?: string }>`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  color: ${(props) => props.$textColor || "var(--black)"};
  display: block;
  margin-bottom: 0.5rem;
  text-align: left;
`;

// Styled PhoneInput component
export const StyledPhoneInput = styled(PhoneInput)<{ $bordercolor?: string }>`
  width: 100%;
  height: 3.125rem;
  background: var(--gray-500);
  font-family: "Montserrat", sans-serif;

  &:focus-within {
    border-radius: 0.125rem;
    border: 2px solid ${(props) => props.$bordercolor || "var(--yellow-500)"};
    outline: none;
  }

  /* Style for the inner phone input container */
  .react-international-phone-input-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    font-family: "Montserrat", sans-serif;
    font-size: 1rem;
    font-weight: 500;
    color: var(--black);
    background: var(--white);
  }

  /* Style for the country selector button */
  .react-international-phone-country-selector-button {
    height: 100%;
    background: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Montserrat", sans-serif;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    outline: none;
    border: none;
    border-right: 2px solid var(--gray-300);
  }

  /* Style for the input itself */
  input.react-international-phone-input {
    flex: 1;
    height: 100%;
    padding: 0 0.5rem;
    margin: 0;
    background: var(--white);
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    color: var(--black);
    outline: none;
    border: none;
    border-radius: 0.125rem;

    &::placeholder {
      font-size: 1rem;
      line-height: 1.5rem;
      color: #b6b6b6;
      font-weight: 800;
    }

    &:-webkit-autofill {
      background: var(--gray-500) !important;
      -webkit-text-fill-color: var(--black) !important;
      transition: background-color 5000s ease-in-out 0s;
    }

    &:-webkit-autofill::first-line {
      font-family: "Montserrat", sans-serif;
      font-size: 1rem;
      font-weight: 500;
    }
  }
`;

export const FormErrorMessage = styled.small`
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: var(--red);
  margin-top: 0.25rem;
  display: block;
`;

export const FormControl = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isInvalid"].includes(prop),
})<{ isInvalid?: boolean }>`
  ${FormLabel} {
    ${(props) =>
      props.isInvalid &&
      css`
        color: var(--red);
      `};
  }

  ${StyledPhoneInput} {
    ${(props) =>
      props.isInvalid &&
      css`
        border: 1px solid var(--red);

        &:not(:focus)::placeholder {
          color: var(--red);
          font-weight: 600;
        }
      `};

    .react-international-phone-input-container {
      ${(props) =>
        props.isInvalid &&
        css`
          border: 1px solid var(--red);

          &:not(:focus)::placeholder {
            color: var(--red);
            font-weight: 600;
          }
        `};
    }
  }
`;
